"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DARK = exports.SHADE = exports.BLANK = exports.DEFAULT = void 0;
var DEFAULT = 'default';
exports.DEFAULT = DEFAULT;
var BLANK = 'blank';
exports.BLANK = BLANK;
var SHADE = 'on-shade';
exports.SHADE = SHADE;
var DARK = 'on-dark';
exports.DARK = DARK;